

















import { Component, Vue } from 'vue-property-decorator'
import TopMenu from '@/components/common/top-menu'
import Footer from '@/components/Footer.vue'
import AssessmentModal from '@/apps/assessment/components/assessment-modal/'
import CustomFooter from '@/components/custom-footer'
import trackMixin from '@/common/trackMixin.js'
import { BLOCK_REGIONS } from '@/components/model/topMenu'

@Component({
  components: {
    TopMenu,
    Footer,
    CustomFooter,
    AssessmentModal
  },
  mixins: [trackMixin]
})
export default class Junior extends Vue {
  public subject() {}
  public get userInfo() {
    return this.$store.state.user_info
  }
  public get isBlockRegion() {
    let section =
      this.userInfo &&
      this.userInfo.regions &&
      this.userInfo.regions.length > 0 &&
      this.userInfo.regions[2]
    return section && BLOCK_REGIONS.includes(String(section.code))
  }
  // 中行用户
  private get isZhongHang() {
    const zhongHangId = 'd5bf4a5ff8876b0f0b5a53f91b65c43a'
    return (
      this.userInfo &&
      this.userInfo.customer_ids &&
      this.userInfo.customer_ids.includes(zhongHangId)
    )
  }
}
